/* Yeslicense — interactions (refonte 2026) */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(html) {
    var t = document.getElementById('yl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'yl-toast';
      t.className = 'yl-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-yl-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Erreur');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'yl-add', data: { itemCount: cart.item_count, source: 'yl' } } }));
          toast('<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6EE7A0" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg><span>' + esc(res.j.product_title || 'Produit') + ' ajouté au panier</span><a href="' + root + 'cart">Voir le panier</a>');
        });
      })
      .catch(function (err) { toast('<span>' + esc(err.message) + '</span>'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-yl-tab]');
    if (!tab) return;
    var group = tab.closest('[data-yl-tabs]');
    if (!group) return;
    group.querySelectorAll('[data-yl-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
    group.querySelectorAll('[data-yl-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-yl-panel') !== tab.getAttribute('data-yl-tab'); });
  });

  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-yl-thumb]');
    if (!th) return;
    var gal = th.closest('.yl-gal');
    var main = gal && gal.querySelector('.yl-main-img img');
    if (!main) return;
    main.removeAttribute('srcset');
    main.src = th.getAttribute('data-yl-thumb');
    gal.querySelectorAll('[data-yl-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === th ? 'true' : 'false'); });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-yl-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    input.value = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-yl-qty'), 10)));
  });

  document.addEventListener('change', function (e) {
    var r = e.target.closest('input[data-yl-variant]');
    if (!r) return;
    var scope = r.closest('[data-yl-product]');
    var cmp = r.getAttribute('data-compare');
    scope.querySelectorAll('[data-yl-price]').forEach(function (el) { el.textContent = r.getAttribute('data-price'); });
    scope.querySelectorAll('[data-yl-compare]').forEach(function (el) { el.textContent = cmp || ''; el.hidden = !cmp; });
    var available = r.getAttribute('data-available') === 'true';
    scope.querySelectorAll('[data-yl-submit]').forEach(function (b) { b.disabled = !available; });
    if (window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState({}, '', u);
    }
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('select[data-yl-sort]');
    if (!s) return;
    var u = new URL(location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });
})();
